'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = require('keycode');

var _keycode2 = _interopRequireDefault(_keycode);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _bootstrapUtils = require('../utils/bootstrapUtils');

var _createChainedFunction = require('../utils/createChainedFunction');

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _ValidComponentChildren = require('../utils/ValidComponentChildren');

var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);

var _safeAttributes = require('../utils/safeAttributes');

var _safeAttributes2 = _interopRequireDefault(_safeAttributes);

var _RootCloseWrapper = require('react-overlays/lib/RootCloseWrapper');

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownMenu = function (_React$Component) {
  _inherits(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    _classCallCheck(this, DropdownMenu);

    var _this = _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call(this, props));

    _this.focusNext = _this.focusNext.bind(_this);
    _this.focusPrevious = _this.focusPrevious.bind(_this);
    _this.getFocusableMenuItems = _this.getFocusableMenuItems.bind(_this);
    _this.getItemsAndActiveIndex = _this.getItemsAndActiveIndex.bind(_this);

    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.onClickBack = _this.onClickBack.bind(_this);
    return _this;
  }

  _createClass(DropdownMenu, [{
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      switch (event.keyCode) {
        case _keycode2.default.codes.down:
          this.focusNext();
          event.preventDefault();
          break;
        case _keycode2.default.codes.up:
          this.focusPrevious();
          event.preventDefault();
          break;
        case _keycode2.default.codes.esc:
        case _keycode2.default.codes.tab:
          this.props.onClose(event);
          break;
        default:
      }
    }
  }, {
    key: 'onClickBack',
    value: function onClickBack() {
      if (this.props.onClickBack) {
        this.props.onClickBack();
      }
    }
  }, {
    key: 'focusNext',
    value: function focusNext() {
      var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
          items = _getItemsAndActiveInd.items,
          activeItemIndex = _getItemsAndActiveInd.activeItemIndex;

      if (items.length === 0) {
        return;
      }

      if (activeItemIndex === items.length - 1) {
        items[0].focus();
        return;
      }

      items[activeItemIndex + 1].focus();
    }
  }, {
    key: 'focusPrevious',
    value: function focusPrevious() {
      var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
          items = _getItemsAndActiveInd2.items,
          activeItemIndex = _getItemsAndActiveInd2.activeItemIndex;

      if (activeItemIndex === 0) {
        items[items.length - 1].focus();
        return;
      }

      items[activeItemIndex - 1].focus();
    }
  }, {
    key: 'getItemsAndActiveIndex',
    value: function getItemsAndActiveIndex() {
      var items = this.getFocusableMenuItems();
      var activeElement = document.activeElement;
      var activeItemIndex = items.indexOf(activeElement);

      return { items: items, activeItemIndex: activeItemIndex };
    }
  }, {
    key: 'getFocusableMenuItems',
    value: function getFocusableMenuItems() {
      var menuNode = _reactDom2.default.findDOMNode(this);

      if (menuNode === undefined) {
        return [];
      }

      return [].slice.call(menuNode.querySelectorAll('[tabIndex="-1"]'), 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _classes;

      var _props = this.props,
          children = _props.children,
          onSelect = _props.onSelect,
          pullRight = _props.pullRight,
          className = _props.className,
          labelledBy = _props.labelledBy,
          open = _props.open,
          onClose = _props.onClose,
          props = _objectWithoutProperties(_props, ['children', 'onSelect', 'pullRight', 'className', 'labelledBy', 'open', 'onClose']);

      var items = _ValidComponentChildren2.default.map(children, function (child) {
        var childProps = child.props || {};

        return _react2.default.cloneElement(child, {
          onKeyDown: (0, _createChainedFunction2.default)(childProps.onKeyDown, _this2.handleKeyDown),
          onSelect: (0, _createChainedFunction2.default)(childProps.onSelect, onSelect)
        }, childProps.children);
      });

      var classes = (_classes = {}, _defineProperty(_classes, (0, _bootstrapUtils.prefix)(this.props, 'menu'), true), _defineProperty(_classes, (0, _bootstrapUtils.prefix)(this.props, 'menu-right'), pullRight), _classes);

      var list = void 0;
      var validProps = (0, _safeAttributes2.default)(props);
      if (this.props.dropdownType === 'navigation') {
        list = _react2.default.createElement(
          'ul',
          _extends({
            className: (0, _classnames2.default)(className, "fe-header-dropdown--opposite-x fe-navigation__sub fe-header-dropdown--transitioning", { "fe-header-dropdown--open fe-header-dropdown--opened": this.props.open }),
            role: 'menu',
            'aria-labelledby': labelledBy
          }, validProps),
          _react2.default.createElement(
            'li',
            { className: 'fe-navigation__back-type' },
            _react2.default.createElement(
              'p',
              { className: 'fe-navigation__back-name' },
              this.props.backTypeName
            ),
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.onClickBack, className: 'fe-navigation__back-link' },
              _react2.default.createElement('i', { className: 'fa fa-chevron-left' }),
              ' Back'
            )
          ),
          items
        );
      } else {
        list = _react2.default.createElement(
          'ul',
          _extends({
            className: (0, _classnames2.default)(className, classes),
            role: 'menu',
            'aria-labelledby': labelledBy
          }, validProps),
          items
        );
      }

      if (open) {
        list = _react2.default.createElement(
          _RootCloseWrapper2.default,
          { noWrap: true, onRootClose: onClose },
          list
        );
      }

      return list;
    }
  }]);

  return DropdownMenu;
}(_react2.default.Component);

DropdownMenu.defaultProps = {
  bsRole: 'menu',
  bsClass: 'dropdown',
  pullRight: false
};

DropdownMenu.propTypes = {
  open: _propTypes2.default.bool,
  pullRight: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  labelledBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onSelect: _propTypes2.default.func,
  dropdownType: _propTypes2.default.string,
  onClickBack: _propTypes2.default.func
};

exports.default = DropdownMenu;